export enum Separator {
  DOT = '.',
  COMMA = ',',
}

export enum Sign {
  PLUS = '+',
  MINUS = '-',
}

export enum SpecialKey {
  LEFT = 'ArrowLeft',
  RIGHT = 'ArrowRight',
  DELETE = 'Delete',
  BACKSPACE = 'Backspace',
}

export class Mark {
  readonly description: string = 'cursor-mark';
}

export const CURSOR_MARK = new Mark();

export type MarkedInput = Array<Mark|string>

export enum Round {
  ROUND = 'round',
  FLOOR = 'floor',
  CEIL = 'ceil',
}

export interface Options {
  prefix?: string,
  suffix?: string,
  separateGroups?: boolean,
  groupSeparator?: Separator,
  radix?: Separator,
  decimals?: number,
  round?: Round,
  alwaysShowDecimals?: boolean,
}
